import {
  handleAddSite,
  handleDeleteSite,
  handleEditSite,
  handleRestoreSite,
} from 'serviceWorker/services/sites';
import { siteSource } from 'serviceWorker/services/sites/siteSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { siteContract } from 'shared/domain/site/siteContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the site requests: one site for its details view, and changes,
 * answered once queued (the outcome follows as an event with their `uniqueId`).
 */
export function serveSiteRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(siteContract, siteSource),
    channelServer.handle(siteContract, {
      getOneById: ({ id }) => siteSource.getOneById(id),
      create: handleAddSite,
      edit: handleEditSite,
      remove: handleDeleteSite,
      restore: handleRestoreSite,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
